<template>
  <div class="productitem">
    <div
      class="item-pic"
      :style="{ backgroundImage: 'url(' + $setPicSize(item.img) + ')' }"
    >
    </div>
    <div class="item-info">
      <div class="item-info-title">
       {{ item.title }}
      </div>
      <div class="item-info-price">
        <div v-if="item.price / 100 > 0">
          ￥<span>{{ item.price / 100 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setPicSize } from '@zz-common/zz-utils'
export default {
  name: 'ProductItem',
  props: ['item'],
  data() {
    return {
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 144, 144)
    }
  }
}
</script>
<style lang="less" scoped>
@import 'index.less';
</style>